import styles from '../../../styles/LoginHelp.module.css';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
// import { isEmpty } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import { appInsights } from '../../../appInsights/appInsights';

const CreateAccount = () => {

  const navigate = useNavigate();
  const [goto,setGoto] = useState("");


  useEffect(()=>{
    setGoto(new URLSearchParams(window.location.search).get('goto') || '')
    appInsights.trackPageView({name: 'Create Account'}); 
  },[])

  return (
    <>
    {/* back to login and header */}
    <div>
      <div className={styles.headerTop}>
        <div className={styles.headerLogin}></div>
      </div>
      <a className={styles.backToLogin} onClick={() => {
                  // navigate("/resetpassword?goto=" + goto);
                  if (isEmpty(goto)) {
                    navigate("/login");
                  } else {
                    navigate("/login?goto=" + goto);
                  }
                }} >
          <div className={styles.backToLoginArrow} >
            <b>{" <-"}</b>
          </div >
          <div className={styles.backToLogintext} >
            Return to Login
          </div>
      </a>
      <div className="banner"  >
          <div className="leftbanner" >{" US and Non-US Persons "}</div >
          <div className="spanCenter">Technical Data<a  style={{textDecoration:'none', color:'#000'}} href="https://rtxusers.sharepoint.us/sites/enghub-PW/_layouts/15/settings.aspx">/</a>Information&nbsp;<strong> Strictly Prohibited</strong></div>
          <div className="rightbanner" >{" US and Non-US Persons "}</div >
      </div>
    </div>
    <div className={styles.contectDiv}>
      <section className={styles.loginHelpSection} style={{borderBottom:"none"}}>
        <div className={styles.loginHelpContentSection}>
          <div className={styles.frameCreateAccount1}>
            <p className={styles.sectionCreateAccountHeader}>Create <br /> Account</p>
            <p className={styles.sectionSubHeader}>To create an account on EngineWise Connect, enrollment via Pratt & Whitney Universal Registration is required.</p>
          </div>
          <section style={{display:"flex",flexDirection:"column"}}>
            <div className={styles.frameLoginHelp2} style={{height:"160px"}}>
              <p className={styles.rightHeader}><b>Enroll as Individual</b></p>
              <p className={styles.rightLoginHelpContent}>Please use the below link if you are registering as a new user for a company that is already setup and working within the EngineWise Connect Portal.</p>
              <button className={styles.createAccountButton} 
                onClick={()=>{
                navigate("/userRegistration")
              }}>
                <div className={styles.createAccountButtonText}>
                Individual Enrollment
                </div>
                </button>
            </div>

            <div className={styles.frameLoginHelp2} style={{height:"160px",marginTop:"32px"}}>
              <p className={styles.rightLoginHelpHeader}><b>Enroll as Company</b></p>
              <p className={styles.rightLoginHelpContent}>Please use the below link if you are a new company or sub-company looking to access the EngineWise Connect Portal.</p>
              <button className={styles.createAccountButton} 
                onClick={()=>{
                navigate("/companyRegistration")
              }}>
                <div className={styles.createAccountButtonText}>
                Company Enrollment
                </div>
              </button>
            </div>

            <div className={styles.frameLoginHelp2} style={{marginTop:"32px", height:"160px"}}>
              <p className={styles.rightLoginHelpHeader}><b>Enrollment Assistance</b></p>
              <p className={styles.rightLoginHelpContent}>For more assistance with EngineWise® Connect Portal enrollment, send an email to the <a href="mailto:gppwolshelpcenter@prattwhitney.com" target="_blank" style={{textDecoration:"none"}} rel="noopener noreferrer">Pratt & Whitney OLS Helpdesk.</a></p>
            </div>
          </section>
          
        </div>
      </section>
    </div>
    </>

  );
};

export default CreateAccount;
